import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { EventVideoViewModel } from 'stageclip-common';

import {
  createAllEventVideosRequestedAction,
  createEventArchivedVideosRequestedAction,
} from '../../../actions/eventVideosActions';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { getAllWithIds, getItem } from '../../../store/selectors';
import DownloadButton from '../../buttons/downloadButton';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../../componentBase';
import { AppTable, AppTableColumn } from '../../table/appTable';

interface EventVideosTableOwnProps {
  eventId: string;
  archived: boolean;
}

interface EventVideosTableStateProps extends BaseStateProps {
  eventVideos: EventVideoViewModel[];
}

interface EventVideosTableDispatchProps extends BaseDispatchProps {
  loadAllEventVideos: (c: EventVideosTable) => void;
}

class EventVideosTable extends ComponentBase<
  EventVideosTableOwnProps,
  EventVideosTableStateProps,
  EventVideosTableDispatchProps
> {
  private columns: AppTableColumn[] = [
    {
      Header: 'Name',
      accessor: (v: EventVideoViewModel) => v.name,
      id: 'name',
    },
    {
      Cell: (row: any) => (row.value ? <DownloadButton url={row.value} /> : 'n/a'),
      Header: 'Download Link',
      accessor: (v: EventVideoViewModel) => v.url,
      id: 'url',
      width: 150,
    },
  ];

  protected dataLoaded(props: any) {
    return props.eventVideos !== undefined;
  }

  protected async loadData(props: any) {
    await props.loadAllEventVideos(this);
  }

  protected loggedInRender() {
    return <AppTable columns={this.columns} tableName="eventVideos" data={this.props.eventVideos} />;
  }
}

function mapStateToProps(state: ClippingPlatformState, ownProps: EventVideosTableOwnProps): EventVideosTableStateProps {
  const event =
    getItem(state.entities.events, ownProps.eventId) || getItem(state.entities.archivedEvents, ownProps.eventId);

  return {
    ...baseMapStateToProps(state),
    eventVideos: event.eventVideos ? getAllWithIds(state.entities.eventVideos, event.eventVideos) : undefined,
  };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: EventVideosTableOwnProps): EventVideosTableDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadAllEventVideos: (c: EventVideosTable) =>
      dispatch(
        !ownProps.archived
          ? createAllEventVideosRequestedAction(ownProps.eventId, c, dispatch)
          : createEventArchivedVideosRequestedAction(ownProps.eventId, c, dispatch),
      ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventVideosTable);
